<script setup>
import PositiveWaves12 from '../../../../assets/lottie/positive_waves_12.json'
import { frames } from '../../../../utils/frames'
const gsapTimeline = useGsapTimeline()

defineProps({
  textA: {
    type: String,
    required: true,
  },
  textB: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['timeline'])

const lineAOutline1Element = ref(null)
const lineAOutline2Element = ref(null)
const lineAOutline3Element = ref(null)
const lineBOutline1Element = ref(null)
const lineBOutline2Element = ref(null)
const lineBOutline3Element = ref(null)

const lineAPreSettlementElement = ref(null)
const lineBPreSettlementElement = ref(null)

const lineAEndElement = ref(null)
const lineBEndElement = ref(null)

const linesEndContainerElement = ref(null)
const endBackshadowElement = ref(null)

const positiveWaves12Element = ref(null)

onMounted(() => {
  const positiveWaves12 = useLottie(positiveWaves12Element.value, PositiveWaves12)

  const timeline = gsapTimeline()
    .set([lineAOutline1Element, lineBOutline1Element], { visibility: 'inherit' })
    .set([lineAOutline2Element, lineBOutline2Element], { visibility: 'inherit' }, '+=0.08')
    .set([lineAPreSettlementElement, lineBPreSettlementElement], { visibility: 'inherit' }, '+=0.04')
    .set([lineAOutline1Element, lineBOutline1Element], { visibility: 'hidden' }, '+=0.04')
    .set([lineAPreSettlementElement, lineBPreSettlementElement], { scale: 2, transformOrigin: 'left center' }, '<')
    .set([lineAOutline3Element, lineBOutline3Element], { visibility: 'inherit' }, '<')
    .set([lineAOutline2Element, lineBOutline2Element], { visibility: 'hidden' }, '+=0.04')
    .set([lineAPreSettlementElement, lineBPreSettlementElement], { visibility: 'hidden' }, '<')
    .fromTo(linesEndContainerElement, { y: -425, scale: 1.8, transformOrigin: 'left center' }, { y: -430, scale: 1, visibility: 'inherit', duration: 0.4 }, '<')
    .set([lineAOutline3Element, lineBOutline3Element], { visibility: 'hidden' }, '<0.12')
    .to(positiveWaves12.playhead, positiveWaves12.animation, '<')
    .to(linesEndContainerElement, { y: 0, duration: 0.56, ease: 'power2.inOut' }, '<.32')
    .from(endBackshadowElement, { yPercent: 100, duration: 0.4, ease: 'power2.out' }, '<.2')
    // End animation
    .to(endBackshadowElement, { yPercent: 100, duration: frames(9), ease: 'power2.in' }, '<4')
    .to(lineAEndElement, { letterSpacing: '-6px', duration: frames(6), ease: 'power3.In' }, '<')
    .to(lineBEndElement, { letterSpacing: '-6px', duration: frames(6), ease: 'power3.In' }, '<' + frames(2))
    .set(lineAEndElement, { visibility: 'hidden' }, '<' + frames(3))
    .set(lineBEndElement, { visibility: 'hidden' }, '<' + frames(3))

  emit('timeline', timeline)
})
</script>

<template>
  <div ref="positiveWaves12Element" class="w-full h-full absolute z-50" />
  <div ref="lineAOutline1Element" class="invisible absolute z-50 -top-3 left-[120px] text-transparent text-[164px] font-semibold text-stroke-3 text-stroke-white whitespace-nowrap" v-text="textA" />
  <div
    ref="lineAOutline2Element"
    class="invisible absolute z-50 top-[130px] left-[120px] text-transparent text-[164px] font-semibold text-stroke-3 text-stroke-white whitespace-nowrap"
    v-text="textA"
  />
  <div
    ref="lineAOutline3Element"
    class="invisible absolute z-50 top-[270px] left-[120px] text-transparent text-[164px] font-semibold text-stroke-3 text-stroke-white whitespace-nowrap"
    v-text="textA"
  />
  <div
    ref="lineBOutline1Element"
    class="invisible absolute z-50 -bottom-3 left-[120px] text-transparent text-[164px] font-semibold text-stroke-3 text-stroke-q-cr-red-primary whitespace-nowrap"
    v-text="textB"
  />
  <div
    ref="lineBOutline2Element"
    class="invisible absolute z-50 bottom-[130px] left-[120px] text-transparent text-[164px] font-semibold text-stroke-3 text-stroke-q-cr-red-primary whitespace-nowrap"
    v-text="textB"
  />
  <div
    ref="lineBOutline3Element"
    class="invisible absolute z-50 bottom-[270px] left-[120px] text-transparent text-[164px] font-semibold text-stroke-3 text-stroke-q-cr-red-primary whitespace-nowrap"
    v-text="textB"
  />
  <div
    ref="lineAPreSettlementElement"
    class="invisible absolute z-50 top-[460px] left-[900px] tracking-[100px] text-transparent text-[30px] font-semibold text-stroke text-stroke-white whitespace-nowrap"
    v-text="textA"
  />
  <div ref="lineBPreSettlementElement" class="invisible absolute z-50 top-[600px] left-[600px] tracking-[100px] text-q-cr-red-primary text-[40px] font-semibold whitespace-nowrap" v-text="textB" />
  <div ref="linesEndContainerElement" class="invisible absolute z-50 bottom-[55px] left-[120px] tracking-[-2.3px] text-white text-[60px] font-semibold whitespace-nowrap">
    <div ref="lineAEndElement" v-text="textA" />
    <div ref="lineBEndElement" class="text-q-cr-red-primary -mt-2" v-text="textB" />
  </div>
  <div ref="endBackshadowElement" class="absolute bottom-0 z-10 bg-gradient-to-b from-transparent to-black h-1/3 w-full" />
</template>
